import { render, staticRenderFns } from "./ProductsMappingPage.vue?vue&type=template&id=0d27d1ff&"
import script from "./ProductsMappingPage.vue?vue&type=script&lang=js&"
export * from "./ProductsMappingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports